<div class="container">
  <h2>{{ data.title }}</h2>
  <span class="dialog-message">{{ data.message }}</span>
  <button
    mat-raised-button
    (click)="dialogRef.close()"
    type="button"
    color="accent"
  >
    {{ translationService.getCloseText() }}
  </button>
</div>
